import { render, staticRenderFns } from "./SharingSummaryReport.vue?vue&type=template&id=5c5dff18&scoped=true"
import script from "./SharingSummaryReport.vue?vue&type=script&lang=js"
export * from "./SharingSummaryReport.vue?vue&type=script&lang=js"
import style0 from "./SharingSummaryReport.vue?vue&type=style&index=0&id=5c5dff18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dff18",
  null
  
)

export default component.exports